// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divCardItem{align-items:center;background-color:#01c2b3;border-radius:10px;color:#fff;display:flex;justify-content:space-between;margin:0 5px;padding:5px}.root>circle{fill:red}.branch>circle{fill:#ff0}.leaf>circle{fill:green;r:40}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
